import { Component, Input, output, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { PlatformModule } from '@app/platform.module';
import { FeatureService } from '@app/services/feature.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-t4-dental-benefit-reminder-dialog',
    templateUrl: './t4-dental-benefit-reminder-dialog.template.html',
    standalone: true,
    imports: [PlatformModule, TranslateModule, RouterLink],
})
export class T4DentalBenefitReminderDialog {
    /**
     * Emits when the dialog is being closed
     */
    closing = output<void>();
    /**
     * Emits when the user requests to generate T4s
     */
    onGenerateT4s = output<void>();
    hasBulkUpdateFeature = signal<boolean>(false);

    private _isOpen = false;

    @Input()
    set isOpen(isOpen: boolean) {
        this._isOpen = isOpen;
    }
    get isOpen(): boolean {
        return this._isOpen;
    }

    constructor(
        public router: Router,
        private featureService: FeatureService
    ) {
        this.featureService.has('payroll-bulk-update-box-45').then(this.hasBulkUpdateFeature.set);
    }

    closeDialog(): void {
        this.isOpen = false;
        this.closing.emit();
    }

    /**
     * Used to display a string array by concatenating the strings
     */
    isNestedArray(content: string | string[]): content is string[] {
        return typeof content !== 'string';
    }
}
